import { latestArticles, hotTopics } from '../../../mocks/knowledgeData';

export default function LatestContent() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-3xl font-bold text-gray-900">最新内容</h2>
              <a 
                href="/articles" 
                className="text-emerald-600 hover:text-emerald-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="space-y-6">
              {latestArticles.map((article) => (
                <article 
                  key={article.id}
                  className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 cursor-pointer group"
                >
                  <div className="flex items-start justify-between mb-3">
                    <span className="px-3 py-1 bg-emerald-50 text-emerald-700 text-xs font-medium rounded-full whitespace-nowrap">
                      {article.category}
                    </span>
                    <div className="flex items-center gap-4 text-xs text-gray-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views}
                      </span>
                    </div>
                  </div>

                  <h3 className="text-lg font-semibold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors leading-relaxed">
                    {article.title}
                  </h3>

                  <div className="flex flex-wrap gap-2 mb-4">
                    {article.tags.map((tag) => (
                      <span 
                        key={tag}
                        className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded whitespace-nowrap"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-2">
                      <i className="ri-links-line text-gray-400 text-sm"></i>
                      <span className="text-xs text-gray-500">
                        关联 {article.relatedCategories.length} 个知识板块
                      </span>
                    </div>
                    <span className="text-sm text-emerald-600 font-medium group-hover:translate-x-1 transition-transform inline-block whitespace-nowrap">
                      阅读全文 →
                    </span>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="sticky top-8 space-y-8">
              <div className="bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl p-6 text-white">
                <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                  <i className="ri-fire-line"></i>
                  热门话题
                </h3>
                <div className="space-y-3">
                  {hotTopics.map((topic, index) => (
                    <div 
                      key={topic.id}
                      className="flex items-center gap-3 p-3 bg-white/10 rounded-lg hover:bg-white/20 transition-colors cursor-pointer backdrop-blur-sm"
                    >
                      <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center font-bold text-sm flex-shrink-0">
                        {index + 1}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium truncate">{topic.title}</div>
                        <div className="text-xs text-white/70 flex items-center gap-1">
                          <i className="ri-fire-fill text-xs"></i>
                          {topic.heat.toLocaleString()} 热度
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-notification-line text-emerald-600"></i>
                  订阅更新
                </h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  订阅我们的资讯，第一时间获取最新的财税政策和行业动态
                </p>
                <form className="space-y-3">
                  <input
                    type="email"
                    placeholder="输入您的邮箱"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-100 transition-all"
                  />
                  <button
                    type="submit"
                    className="w-full px-4 py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-medium rounded-lg hover:from-emerald-600 hover:to-teal-600 transition-all whitespace-nowrap"
                  >
                    立即订阅
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}